class Activity {

	static fromArray(data) {
		let inst = new Activity();
		inst.loadArray(data);
		return inst;
	}

	static placeholder (id) {
		let inst = new Activity();
		inst._id = id;
		inst.text = _("Loading....");
		inst.color = DEFAULT_ACTIVITY_COLOR;

		return inst;
	}

	static suggest(name, color, graphic) {
		let inst = new Activity();

		inst.text = name.charAt(0).toUpperCase() + name.slice(1);
		if (typeof graphic !== 'undefined') {
			inst.graphicId = graphic;
		}
		inst.color = '#' + color;
		inst._ownerId = null;

		return inst;
	}

	constructor() {
		this._id = 0;
		this._text = '';
		this._graphicId;
		this._color;

		this._energy;
		this._level;
		this._copyOf = 0;

		this._entityAccess = AC.ACCESS_OWNER;
		this._editable = 1;
		this._linkData = 0;

		this.updates = {};
		this._linkDataUpdated = false;

		this._events = [];  // array of events that use this activity
	}

	loadArray(data) {
		this._id = data._id;
		this.text = data._text;
		this.graphicId = data.graphic_id;
		this.color = data.color;

		this._energy = data.energy;
		this._level = data.detail_level;
		this._copyOf = data.copy_of;

		this._ownerId = data.owner_id;
		this._ownerName = data.owner_name;

		// this._itemCount = data.item_count;
		// this._entityAccess = data.shift();
		// this._otherAccess = data.shift();
		this._editable = data.edit;
		this._share = data.share;
		this._own = 0;

		this.applyUpdates();
		this.updateEvents();
	}

	copy() {
		if (this._id == 0) return this;

		let inst = new Activity();

		inst._text = this.text;
		inst._graphicId = this.graphicId;
		inst.color = this.color;
		inst._energy = this.energy;
		inst._level = this.level;
		inst._copyOf = this.id;

		return inst;
	}

	get isSuggestion() {
		return this._ownerId == null;
	}

	get isShareable() {
		return this._entityAccess >= AC.ACCESS_FULL;
	}

	get isEditable() {
		return this._editable;
	}

	get(property) {
		return this.updates.hasOwnProperty(property) ?
			this.updates[property] :
			this[property];
	}
	get id() {
		return this._id;
	}
	set id(activityId) {
		// only allow id to be set for new activities where id is currently 0
		if (this._id !== 0) {
			return false;
		}
		this._id = activityId;
		return true;
	}
	get text() {return this.get('_text');}
	set text(value) {
		if (value === null || value === '')
			showToast(_("Please enter a name first"));
		else
			this.updates._text = value;
	}
	hasGraphic() {
		return !!this.graphicId;
	}
	
	get graphicId() {return this.get('_graphicId');}
	set graphicId(value) {
		this.updates._graphicId = value;
	}

	get color() {return this.get('_color')}
	set color(color) {
		if (color === null || color === "")
			this.updates._color = DEFAULT_ACTIVITY_COLOR;
		else
			this.updates._color = color.length === 6 ? "#" + color : color;
	}
	hasLinkData() {
		return !!this.linkData;
	}

	get linkData() {return this._linkData;}
	set linkData(data) {
		if (this._linkData === data) return;
		this._linkDataUpdated = true;
		this._itemCount = data.length;
		this._linkData = data;
	}

	get level() {return this.get('_level');}
	set level(level) {
		this.updates._level = level;
	}

	get energy() {return this.get('_energy');}
	set energy(energy) {
		this.updates._energy = energy;
	}

	get itemCount() {return this._itemCount;}

	get ownerName() {return this._ownerName;}

	get copyOf() {return this.get('_copyOf');}
	set copyOf(value) {
		this.updates._copyOf = value;
	}
	
	getPreviewElem(icons) {
		let iconsRow = UI.div();
		if (icons & 1) iconsRow.appendChild(UI.icon('guide', 20));
		if (icons & 2) iconsRow.appendChild(UI.icon('checklist', 20));
		if (icons & 4) iconsRow.appendChild(UI.icon('repeat', 20));
		if (icons & 8) iconsRow.appendChild(UI.icon('group', 20));

		let elem = UI.div(null, [
			UI.img(null, graphicSrc(this.graphicId, AC.GRAPHIC_SML)),
			UI.span(null, this.text),
			iconsRow
		]);
		elem.style.backgroundColor = this.color;
		elem.style.color = getContrastColor(this.color);
		return elem;
	}

	get card() {
		let card = UI.div('activity-card', null, {
			'click': () => globalTimeline.onActivitySelected(this, this.isSuggestion)
		});
		let name = this.isSuggestion ? entityName : this.ownerName;
		if (this.isSuggestion) {
			card.appendChild(div('new-banner'));
		}

		card.style.backgroundColor = this.color;
		card.style.color = getContrastColor(this.color);

		let graphic = this.hasGraphic() ?
			UI.div('flex-0 activity-card-graphic', UI.img(null, graphicSrc(this.graphicId, AC.GRAPHIC_SML))):
			null;

		card.appendChild(UI.div('flex', [
			graphic,
			UI.div('flex-1', [
				UI.div(null, span('card-title', this.text)),
				UI.div(null, span('small', name)),
			])
		]));

		return card;
	}

	save() {
		for (let p in this.updates) {
			if (this.updates[p] === this[p]) delete this.updates[p];
		}
		if (isEmpty(this.updates) && !this._linkDataUpdated) return;
		saveManager.queue(this);
	}

	saveNow() {
		API.upsert('activities', this.id, {
			text: this.text,
			graphic: this.graphicId,
			color: this.color.substring(1),
			copyOf: this.copyOf,
			linkedItems: this.hasLinkData() ? this.linkData : 0
		})
		.then(reply => {
			if (!this.id && reply.id) {
				this.id = reply.id;
				globalTimeline.activities.addActivity(this);
			}
			saveManager.nudge();
			this.applyUpdates();
			this.updateEvents();
		})
	}

	applyUpdates() {
		for (let p in this.updates) {
			this[p] = this.updates[p];
		}
		this.clearUpdates();
	}

	clearUpdates() {
		this.updates = {};
	}

	addEvent(event) {
		if (this._events.indexOf(event) === -1) this._events.push(event);
	}

	removeEvent(event) {
		let i = this._events.indexOf(event);
		if (i !== -1) this._events.splice(i, 1);
	}

	updateEvents() {
		for (let i = 0, ii = this._events.length; i < ii; i++) {
			this._events[i].onActivityChange();
		}
	}
}